<template>
    <section class="flex justify-center font-poppins overflow-hidden">
        <div class="mt-6">
            <img style="width:50%; margin:auto" src="./assets/network-error.png" alt="error">
            <div class="text-center text-blue-600">
                <p class="font-bold text-2xl mb-5">Network Error</p>
                <p>Check that you are connected to the internet</p>
                 <div class="mt-6">
                    <button @click="reload" class="pl-10 pr-10 pt-1 pb-1 rounded-xl text-white bg-blue-600">Reload</button>
                </div>
            </div>
           
            
        </div>
    </section>
</template>

<script>
export default {
    methods: {
        reload() {
            this.$router.go(-1)
        }
    }
}
</script>